import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const Protected = ({ children }) => {
    const authStore = useSelector((state) => state.auth);
    if (authStore.authData.msisdn == process.env.REACT_APP_DUMMY_NUMBER) return <Navigate to="/signin" replace />
    return children
}

export default Protected